import { RouteRecordRaw } from 'vue-router';
import AdminAdmins from '@/components/pages/admin/Admins.vue';
import AdminClient from '@/components/pages/admin/Client.vue';
import AdminClients from '@/components/pages/admin/Clients.vue';
import AdminDefaultPromptSettings from '@/components/pages/admin/DefaultPromptSetting.vue';
import Admin from '@/components/pages/admin/Index.vue';
import AdminSendgridSubUsers from '@/components/pages/admin/SendgridSubUsers.vue';
import AdminUsers from '@/components/pages/admin/Users.vue';
import { i18nGlobal as i18n } from '@/i18n';

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin',
    component: Admin,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'clients',
        name: 'AdminClients',
        component: AdminClients,
        meta: {
          rule: 'isAdmin',
          title: i18n.t('clientManagement.title'),
        },
      },
      {
        path: 'client/:id(\\d+)',
        name: 'AdminClient',
        component: AdminClient,
        props: route => ({ id: Number(route.params.id) }),
        meta: {
          rule: 'isAdmin',
          title: i18n.t('clientManagement.detailTitle'),
        },
      },
      {
        path: 'admins',
        name: 'AdminAdmins',
        component: AdminAdmins,
        meta: {
          rule: 'isAdminOwner',
          title: i18n.t('adminManagement.title'),
        },
      },
      {
        path: 'sendgrid-sub-users',
        name: 'AdminSendgridSubUsers',
        component: AdminSendgridSubUsers,
        meta: {
          rule: 'isAdmin',
          title: i18n.t('sendgridSubUserManagement.title'),
        },
      },
      {
        path: 'default-prompt-settings',
        name: 'AdminDefaultPromptSettings',
        component: AdminDefaultPromptSettings,
        meta: {
          rule: 'isAdmin',
          title: i18n.t('defaultPromptSetting.title'),
        },
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: AdminUsers,
        meta: {
          rule: 'isAdmin',
          title: i18n.t('userForAdmin.title'),
        },
      },
      // 以下はリダイレクト設定なので必ず末尾に記述する
      {
        path: '/admin:pathMatch(.*)*',
        redirect: { name: 'AdminClients' },
        meta: {
          rule: 'isAdmin',
        },
      },
      {
        path: '/admin',
        redirect: { name: 'AdminClients' },
        meta: {
          rule: 'isAdmin',
        },
      },
    ],
  },
];
